import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 6,
    border: `1px solid ${theme.palette.grey[300]}`,
    margin: '8px 0px'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  iconButton: { padding: 0 },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 2),
    flex: '0 0 auto'
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  roomHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 500,
    marginBottom: 8
  },
  icon: { fontSize: 20, color: theme.palette.text.primary, marginRight: 6 },
  verticalAlign: {
    fontWeight: 500,
    display: 'flex',
    verticalAlign: 'middle',
    lineHeight: '22px',
    color: theme.palette.text.primary
  },

  greyText: { fontWeight: 600, color: theme.palette.grey[600] },
  blackText: { fontWeight: 600, color: theme.palette.text.primary },
  table: {
    display: 'flex',
    flexDirection: 'column',
    padding: 6,
    background: theme.palette.background.default,
    margin: '12px 0px',
    borderRadius: 6,
    border: `1px solid ${theme.palette.grey[300]}`
  },
  tableHeader: {
    display: 'grid',
    padding: 4,
    background: theme.palette.grey[200],
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr'
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '8px 0 8px 0'
  },
  tableRow: {
    display: 'grid',
    padding: 4,
    margin: '4px 0',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr'
  },
  tableRowForPerRoomstay: {
    display: 'grid',
    padding: 4,
    margin: '4px 0',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr'
  },
  roomContainer: { margin: '4px 0' },
  tableRowDark: {
    background: theme.palette.grey[200]
  },
  tableHeaderForRoomStay: {
    display: 'grid',
    padding: 4,
    background: theme.palette.grey[200],
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr'
  },
  tableHeaderForDiscounts: {
    display: 'grid',
    padding: 4,
    background: theme.palette.grey[200],
    gridTemplateColumns: '1fr 1fr 1fr '
  },
  tableHeaderForTax: {
    display: 'grid',
    padding: 4,
    background: theme.palette.grey[200],
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr'
  },
  cell: {
    textAlign: 'center',
    color: theme.palette.grey[700],
    fontWeight: 500
  },
  divider: { margin: '4px 0' },
  scrollWrapper: {
    [theme.breakpoints.down('sm')]: {
      // disable horizontal scrolling on larger screens
      overflowX: 'visible'
    },
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    WebkitOverflowScrolling: 'touch',
    // allow the scroll wrapper to size correctly
    display: 'block',
    // optional: visually separate scroll area
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      // disable horizontal scrolling on larger screens
      overflowX: 'visible'
    },
    '&::-webkit-scrollbar': {
      height: 6
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 3
    }
  },
  scrollRow: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(2),
      // ensure children don't wrap to a new line
      flexWrap: 'nowrap',
      alignItems: 'stretch'
    }
  }
}))
